import type { ReactNode, Ref } from 'react'
import cx from 'classnames'
import styles from './NotificationsSidebar.module.css'
import { useCssTransition } from '@/hooks/transition-hooks'

export interface NotificationsSidebarProps {
  showing: boolean
  onClose: () => unknown
  mainRef: Ref<HTMLDivElement>
  menu?: ReactNode
  header?: ReactNode
  list?: ReactNode
}

export function NotificationsSidebar({
  showing,
  onClose,
  mainRef,
  menu,
  header,
  list,
}: NotificationsSidebarProps) {
  // Unmounted while closed so its workspace selector doesn't duplicate the
  // page's `workspace-selector-dropdown` off-screen.
  const [transitionRef, rendering, hidden] = useCssTransition(showing)
  return (
    rendering && (
      <div
        className={cx(styles.root, !hidden && styles.showing)}
        data-test="NotificationsSidebar"
        ref={transitionRef}
      >
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- Click-to-dismiss backdrop; a mouse-only shortcut beside the panel's own close control. */}
        <div className={styles.overlay} onClick={onClose} />
        <div className={styles.panel}>
          {menu}
          <div className={styles.main} ref={mainRef}>
            {header}
            {list}
            <div className={styles.gradient} />
          </div>
        </div>
      </div>
    )
  )
}
